/**
 * Shared API utilities for history entry operations (undo/restore)
 */

export interface HistoryActionResponse {
  success?: boolean
  message?: string
  error?: string
}

function getCsrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
}

async function postHistoryAction(url: string): Promise<HistoryActionResponse> {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
  })

  if (!response.ok) {
    const data = await response.json() as HistoryActionResponse
    throw new Error(data.error || 'Request failed. Please try again.')
  }

  return response.json() as Promise<HistoryActionResponse>
}

/**
 * Undo the last history entry change for a project
 */
export async function undoHistory(projectId: number): Promise<HistoryActionResponse> {
  return postHistoryAction(`/projects/${projectId}/history_entries/undo`)
}

/**
 * Restore (rewind) to a specific history entry
 */
export async function restoreHistory(projectId: number, entryId: number): Promise<HistoryActionResponse> {
  return postHistoryAction(`/projects/${projectId}/history_entries/${entryId}/restore`)
}
